import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { useRouting } from '../../shared/use-routing';
import { DEFAULT_LANGUAGE } from '../../../i18n/i18n';
import styles from './PhoneSupportNotice.css';

const cx = classnames.bind(styles);

function PhoneSupportNotice({ withComingSoon }) {
    const { t } = useTranslation();
    const { lang } = useRouting();

    if (lang === DEFAULT_LANGUAGE) {
        return null;
    }

    return (
        <div className={cx('root', { full: withComingSoon })}>
            <span className={cx('englishOnly', { prominent: withComingSoon })} role='note'>
                {t('common.phoneEnglishOnly')}
            </span>
            {withComingSoon && (
                <span className={styles.comingSoon}>{t('common.germanPhoneSupportSoon')}</span>
            )}
        </div>
    );
}

PhoneSupportNotice.propTypes = {
    withComingSoon: PropTypes.bool
};

PhoneSupportNotice.defaultProps = {
    withComingSoon: false
};

export {
    PhoneSupportNotice
};
